/*
 * Copyright (c) 2024-2026 Nodals AI Ltd
 * All rights reserved.
 */

/**
 * Resolves a dotted path against an object graph using property reads only —
 * functions are never invoked. A numeric segment indexes an array or a numeric
 * object key identically (`obj['2']`), which is what makes gtag-style
 * `dataLayer` entries `{"0": "event", "1": "page_view", "2": {…}}` addressable
 * as `2.central`.
 *
 * Returns `undefined` when the path cannot be fully resolved, or when a
 * function is encountered mid-path or as the final value.
 */
const resolvePath = (root: unknown, path: string): unknown => {
  let current: any = root;
  for (const segment of path.split('.')) {
    if (current == null || typeof current === 'function') {
      return undefined;
    }
    current = current[segment];
  }
  return typeof current === 'function' ? undefined : current;
};

export { resolvePath };
